import React, { useContext, useEffect, useMemo, useState } from "react";
import DetailLayout from "../components/DetailLayout";
import SignInHeader from "./components/SignInHeader";
import SignInTable from "./components/SignInTable";
import SignInFilter, {
    FilterValue,
    StatusType
} from "./components/SignInFilter";
import classes from "./index.module.scss";
import useRequest from "utils/useRequest";
import {
    getSignInfo,
    getStuSignInList,
    SignStatus,
    StuSignInStatus,
    updateAllStuSignStatus
} from "service/signIn";
import { RouteComponentProps } from "react-router-dom";
import { toNumber } from "service/service";
import _ from "underscore";
import { Spin } from "antd";
import { useSearchParam } from "react-use";
import { CourseContext } from "../Store";
import { getStuOnlineSignInList, SignType, StuSignIn } from "service/signIn";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import NumberPad from "./components/NumberPad";
import classNames from "classnames";
import lodash from "lodash-es";

interface SignInDetailProps {
    signInId: string;
}

export default function SignInDetail({
    match
}: RouteComponentProps<SignInDetailProps>) {
    const signInId = toNumber(match.params.signInId);
    const { course } = useContext(CourseContext);
    const status = (useSearchParam("status") as StatusType) || "all"; // 默认过滤状态
    const [data, setData] = useState<StuSignIn[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const [detail, detailStatus, updateDetail] = useRequest(() =>
        getSignInfo(signInId)
    );

    useEffect(() => {
        if (!detail) return;
        getAllStuList(detail.type);
    }, [detail]);

    async function getAllStuList(type: SignType) {
        setLoading(true);
        try {
            if (type === SignType.Live) {
                const data = await getStuOnlineSignInList(signInId);
                setData(data);
            } else {
                const data = await getStuSignInList(signInId);
                setData(data);
            }
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
        setLoading(false);
    }

    const [filter, setFilter] = useState<FilterValue>({ status, text: "" });

    // 统计签到人数
    const statics = useMemo(() => {
        const statics = {
            courseStuCount: data?.length || 0,
            signInStuCount: 0,
            notSingInStuCount: 0
        };

        _.forEach(data || [], item => {
            if (
                [
                    StuSignInStatus.Done,
                    StuSignInStatus.Leave,
                    StuSignInStatus.Late,
                    StuSignInStatus.Unreachable
                ].includes(item.signStatus)
            ) {
                statics.signInStuCount++;
            } else {
                statics.notSingInStuCount++;
            }
        });

        return statics;
    }, [data]);

    // 筛选数据
    const filteredData = useMemo(() => {
        if (!data) return [];
        const _data = data
            .filter(item => {
                if (item.name.indexOf(filter.text) !== -1) return true;
                return item.studentno === filter.text;
            })
            .filter(item => {
                if (filter.status === "all") return true;
                if (
                    filter.status === "sign" &&
                    [
                        StuSignInStatus.Late,
                        StuSignInStatus.Done,
                        StuSignInStatus.Leave
                    ].includes(item.signStatus)
                ) {
                    return true;
                }
                return (
                    filter.status === "unSign" &&
                    [StuSignInStatus.Idle].includes(item.signStatus)
                );
            });

        if (detail?.status === SignStatus.InProgress) {
            return lodash.orderBy(_data, ["signStatus"], ["desc"]);
        } else {
            return _data;
        }
    }, [data, filter]);

    async function updateAll() {
        await updateDetail();
    }

    // 一键签到
    async function onSignAll() {
        await updateAllStuSignStatus(signInId);
        window.location.reload();
    }

    const isNumbering = useMemo(() => {
        if (
            detail?.type === SignType.Number &&
            detail?.status === SignStatus.InProgress
        ) {
            return true;
        } else {
            return false;
        }
    }, [detail]);

    return (
        <DetailLayout breadcrumb="签到详情">
            {detail && (
                <SignInHeader
                    data={detail}
                    onStatusChange={updateAll}
                    weekTimeId={course.weekTimeId}
                    onCountDown={updateAll}
                />
            )}

            <div className={classes.body}>
                <Spin spinning={detailStatus.loading || loading}>
                    <SignInFilter
                        {...statics}
                        filter={filter}
                        onChange={setFilter}
                        onSignAll={onSignAll}
                    />

                    <div className={classNames(classes.isNumbering)}>
                        {isNumbering && (
                            <NumberPad
                                refreshTime={detail?.refreshTime || 10}
                                code={detail?.code || ""}
                                signInId={signInId}
                            />
                        )}
                        <div className={classes.right}>
                            {detail?.status && (
                                <SignInTable
                                    key={detail?.status}
                                    signInId={signInId}
                                    signStatus={detail?.status}
                                    data={filteredData}
                                    onChange={updateAll}
                                    type={detail?.type}
                                />
                            )}
                        </div>
                    </div>
                </Spin>
            </div>
        </DetailLayout>
    );
}
